import React, { useState, useEffect } from "react";
import { secondsToTime } from "../../utilities/scoringUtilities";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import scoringService from "../../services/ScoringService";
import UseFullPageLoaderHook from "./Hook/UseFullPageLoaderHook";

const ScoringInputDetailModal = (props) => {
  const { onHide, showScoringInputDetailModal, onShow, data, fixtureRoomId } = props;
  const [enteredUserSupremacy, setEnteredUserSupremacy] = useState(null);
  const [enteredNotes, setNotes] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  let handleUserSupremacyChange = (event) => {
    setEnteredUserSupremacy(event.target.value);
  };
  let handleNotesChange = (event) => {
    setNotes(event.target.value);
  };

  const [loader, showLoader, hideLoader] = UseFullPageLoaderHook();

  useEffect(() => {
    setEnteredUserSupremacy(data.userEnteredSupremacy);
    setErrorMessage(null);
    setNotes(data.midClipNotes);
  }, [data]);

    const handleConfirm = async () => {
        try {
          showLoader();
          onHide()
          if (enteredUserSupremacy >= -7 && enteredUserSupremacy <= 7) {
              await scoringService.adjustMidClip(
                  fixtureRoomId,
                  enteredUserSupremacy,
                  data.id,
                  data.midClipId,
                  data.time,
                  enteredNotes
              );  
          } else {
            onShow();
            setErrorMessage("Adjusted supremacy must be between 7 and -7");
          }
          hideLoader();
        } catch (err)
        {
          onShow();
          hideLoader();
          if (err || err.data || err.data.error) {
            setErrorMessage(err.data.error ? err.data.error : err.data)
          } else {
            setErrorMessage("An error occurred");
          }
        }

    }

  let errorLabel =
    errorMessage && errorMessage.length > 0 ? (
      <span className="text-danger">{errorMessage}</span>
    ) : (
      <></>
    );

  let customPadding = "0 0 0.5rem";
  let removeSupremacyButton = data.userEnteredSupremacy ? (
    <Button
      type="button"
      variant="primary"
      disabled={false}
      className="mr-2"
      onClick={async (clickInfo) => {
        try {
          showLoader();
          onHide();
          await scoringService.deleteMidClip(fixtureRoomId, data.midClipId);
          hideLoader();
        } catch (err) {
          onShow();
          hideLoader();
          if (err || err.data || err.data.error) {
            setErrorMessage(err.data.error ? err.data.error : err.data)
          } else {
            setErrorMessage("An error occurred");
          }
        }
      }
    }
    >
      Remove Mid Clip
    </Button>
  ) : (
    <></>
  );
  return (
    <div>
    <Modal
      show={showScoringInputDetailModal}
      onHide={onHide}
      backdrop="static"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h3>MID CLIP</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{ height: "500px", maxHeight: "500px", overflowY: "scroll" }}
      >
        <Row style={{ padding: customPadding }}>
          <Col md="6">Current Clip #:</Col>
          <Col md="2">{data.clipNumber}</Col>
        </Row>
        <Row style={{ padding: customPadding }}>
          <Col md="6">Clip Start Supremacy:</Col>
          <Col md="2">{data.startSupremacy}</Col>
        </Row>
        <Row>
          <Col md="6">Clip End Supremacy:</Col>
          <Col md="2">{data.endSupremacy ? data.endSupremacy : ''}</Col>
        </Row>
        <br></br>
        <Row style={{ padding: customPadding }}>
          <Col md="6">Video Time:</Col>
          <Col md="2">{secondsToTime(data.time)}</Col>
        </Row>
        <Row style={{ padding: customPadding }}>
          <Col md="6">Current Supremacy</Col>
          <Col md="2">{data.currentSupremacy}</Col>
        </Row>
        <Row>
          <Col>{errorLabel}</Col>
        </Row>
        <Row style={{ padding: customPadding }}>
          <Col md="6">Supremacy Adj To</Col>
          <Col md="6">
            <Form.Control
              id="supremacyadjInput"
              type="number"
              value={enteredUserSupremacy}
              onChange={handleUserSupremacyChange}
              placeholder="Adj Supremacy"
            />
          </Col>
        </Row>
        <Row>
          <Col md="6">Notes</Col>
          <Col md="6">
            <Form.Control
              id="notesInput"
              as="textarea"
              rows={5}
              value={enteredNotes ? enteredNotes : ""}
              onChange={handleNotesChange}
              placeholder="Free Text"
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="danger"
          onClick={async (clickInfo) => {
            setErrorMessage(null);
            onHide();
          }}>
          Cancel
        </Button>
        {removeSupremacyButton}

        <Button
          type="button"
          variant="primary"
          disabled={!enteredUserSupremacy}
          onClick={async (clickInfo) => {
            handleConfirm()
          }}
        >
          Confirm
        </Button>
      </Modal.Footer>
      </Modal>
      {loader}
    </div>
  );
};

export default ScoringInputDetailModal;
